// src/routers/RouteGuard.js
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { hasPagePermission, isSystemAdminSession } from '../utils/accessControl';

const PERMISSIONS_BOOTSTRAP_KEY = 'smart_permissions_bootstrap_pending';
const PERMISSIONS_UPDATED_EVENT = 'smart-permissions-updated';

function useGateDecision() {
  const loc = useLocation();
  const [, forceUpdate] = useState(0);
  const [bootstrapping, setBootstrapping] = useState(() => localStorage.getItem(PERMISSIONS_BOOTSTRAP_KEY) === '1');

  useEffect(() => {
    const onPermissionsUpdated = () => {
      setBootstrapping(false);
      forceUpdate((value) => value + 1);
    };
    const timer = window.setTimeout(() => setBootstrapping(false), 4000);
    window.addEventListener(PERMISSIONS_UPDATED_EVENT, onPermissionsUpdated);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener(PERMISSIONS_UPDATED_EVENT, onPermissionsUpdated);
    };
  }, []);

  const perms = (() => {
    try {
      return JSON.parse(localStorage.getItem('permissions') || '[]');
    } catch {
      return [];
    }
  })();

  // System Admin (role_id = 1) bypasses every route check — mirrors the
  // backend `is_system_admin` safety net.
  const allowed =
    isSystemAdminSession() || hasPagePermission(perms, [], loc.pathname);
  const pending =
    !allowed &&
    Boolean(localStorage.getItem('role_id')) &&
    (bootstrapping || localStorage.getItem(PERMISSIONS_BOOTSTRAP_KEY) === '1');

  return { allowed, pending };
}

// يلفّ children (لو حبيت تستخدمه كـ HOC)
export default function RouteGuard({ children }) {
  const { allowed, pending } = useGateDecision();
  if (pending) return null;
  return allowed ? children : <Navigate to="/No-access" replace />;
}

// للاستخدام داخل الراوتر كعنصر وسيط
export function RouteGuardOutlet() {
  const { allowed, pending } = useGateDecision();
  if (pending) return null;
  return allowed ? <Outlet /> : <Navigate to="/No-access" replace />;
}
